import {api} from "../services/Api";
import {Button} from "react-bootstrap";
import {copyToClipboard} from "./copyToClipboard";

/**
 * Botoes do boleto aberto por link (bot de WhatsApp). Recebe o JWT do cliente ja emitido pelo login feito na
 * pagina de autenticacao (com o link assinado, ou apos o codigo do segundo fator); nao faz login por conta
 * propria, porque o /login com segundo fator ligado pode devolver o desafio em vez do token.
 */
export function downloadInvoice(token, invoiceId, pix = false) {
	const headers = {
		'Authorization': 'Bearer ' + token,
		'Content-Type': 'application/json',
	};

	function baixarBoleto() {
		api.get('v1/pessoas/clientes/boleto/' + invoiceId, {responseType: 'blob', headers})
			.then((response) => {
				let newBlob = new Blob([response.data], {type: "application/pdf"})
				const data = window.URL.createObjectURL(newBlob);
				let link = window.document.createElement('a');
				link.href = data;
				link.download = "NetComet_Boleto_" + invoiceId + ".pdf";
				link.click();
				setTimeout(function () {
					window.URL.revokeObjectURL(data);
				}, 100);
			}).catch(() => {
				alert('Problema ao baixar o boleto!')
			})
	}

	function copiarLinhaDigitavel() {
		api.get('v1/pessoas/clientes/linha-digitavel-boleto/' + invoiceId, {headers})
			.then((response) => {
				try {
					copyToClipboard(response.data.dados);
					alert('Código copiado com sucesso!')
				} catch (e) {
					alert('Problema ao copiar código do boleto!')
				}
			}).catch(() => {
				alert('Problema ao buscar código do boleto!')
			});
	}

	function copiarQrCodePix() {
		api.get('v1/pessoas/clientes/qrcode-boleto/' + invoiceId, {headers})
			.then((response) => {
				try {
					copyToClipboard(response.data.dados);
					alert('Pix copiado com sucesso!')
				} catch (e) {
					alert('Problema ao copiar código do boleto!')
				}
			}).catch(() => {
				alert('Problema ao buscar código do boleto!')
			});
	}

	return (
		<>
			<Button
				variant="light"
				className="justify-content-center align-items-center d-flex w-100"
				onClick={() => {
					baixarBoleto();
				}}
			>
				<span className="material-icons title-icon">download</span>
				Clique para Baixar o Boleto
			</Button>
			{pix && <>
				<Button
					variant="light"
					className="mt-3 justify-content-center align-items-center d-flex w-100"
					onClick={() => {
						copiarQrCodePix();
					}}
				>
					<span className="material-icons title-icon">pix</span>
					Pagar via Pix
				</Button>
			</>}
			{!pix && <>
				<Button
					variant="light"
					className="mt-3 justify-content-center align-items-center d-flex w-100"
					onClick={() => {
						copiarLinhaDigitavel();
					}}
				>
					<span className="material-icons title-icon">content_copy</span>
					Clique para Copiar Código do Boleto
				</Button>
			</>}
		</>
	);
}
